import request from '@/utils/request'

export function login(data) {
    return request({
        // url: '/user/login',
        url: '/login',
        method: 'post',
        data
    })
}

export function getInfo() {
    return request({
        url: '/api/user/userInfo',
        method: 'get',
    })
}
export function getmenu(data) {
    return request({
        url: '/api/menu/allRoot',
        method: 'get',
    })
}
export function finUserList(data) {
    return request({
        url: '/api/sysdaparment/findUserAll',
        method: 'post',
        data
    })
}

export function logout() {
    return request({
        url: '/user/logout',
        method: 'post'
    })
}
